import { render, staticRenderFns } from "./ParticipantDetailStudyScheduleWeeksNavComponent.vue?vue&type=template&id=1d5f981a&scoped=true&"
import script from "./ParticipantDetailStudyScheduleWeeksNavComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantDetailStudyScheduleWeeksNavComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantDetailStudyScheduleWeeksNavComponent.vue?vue&type=style&index=0&id=1d5f981a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f981a",
  null
  
)

export default component.exports